export { default as Question } from "./Question";
